"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logout = void 0;
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("./utils");
const logout = async () => {
    try {
        const config = {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };
        const refreshToken = localStorage.getItem('refreshToken');
        const accessToken = localStorage.getItem('accessToken');
        (0, utils_1.removeLocalStorageItems)();
        const { data } = await axios_1.default.post('/api/auth/logout', { refreshToken, accessToken }, config);
        window.location = data.redirectUrl;
    }
    catch (err) {
        if (err.status === 500) {
            throw new Error('Logout was not successful');
        }
        else {
            throw err;
        }
    }
};
exports.logout = logout;
